"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SiteCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SiteCardModule = _interopRequireDefault(require("../../styles/components/MapPanel/SiteCard.module.css"));
require("react-lazy-load-image-component/src/effects/blur.css");
var _selectors = require("../../redux/selectors");
var _images = require("../../images");
var _actions = require("../../redux/actions");
var _constants = require("../../utils/constants");
var _Types = require("../../Types");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
const SiteCard = props => {
  const {
    card,
    index,
    show = true,
    isForMap = false,
    goTo
  } = props;
  const {
    hasimages = [],
    id,
    thingSiteAddress,
    thingZIPCode,
    thingCity
  } = card || {};
  const webpSupport = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getWebpSupport);
  const isSignalSite = (0, _reactRedux.useSelector)(_selectors.getIsSingleSite);
  const activeSite = (0, _reactRedux.useSelector)(_selectors.selectActiveSiteId);
  const dispatch = (0, _reactRedux.useDispatch)();
  const isActive = activeSite === id && !isForMap;
  const tV = (0, _paulCorePackage.useTranslationValue)();
  const handleClick = () => {
    dispatch((0, _actions.setActiveSite)(id));
    goTo === null || goTo === void 0 ? void 0 : goTo({
      siteId: id
    });
  };

  /** @todo: need to add index from backend for fixing */
  const number = index > 8 ? index + 1 : "0".concat(index + 1);
  return /*#__PURE__*/_react.default.createElement(_material.Card, {
    onClick: handleClick,
    sx: {
      background: 'white',
      boxShadow: _constants.styles.boxShadow.secondary,
      borderRadius: _constants.styles.borderRadius.card,
      padding: '10px 14px 25px',
      width: '230px',
      border: "2px solid ".concat(isActive ? _constants.colors['main-color-cl-02'] : 'transparent'),
      marginBottom: 2,
      transition: "all ".concat(_constants.styles.transitionType.primary),
      opacity: show ? 1 : 0,
      pointerEvents: show ? 'auto' : 'none',
      cursor: 'pointer'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    variant: "subtitle1",
    sx: {
      fontWeight: 'bold',
      lineHeight: '100%',
      color: _constants.colors['main-color-cl-01']
    }
  }, isSignalSite ? '' : number), /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    wrapperClassName: _SiteCardModule.default.lazy_load_image,
    onError: event => {
      // eslint-disable-next-line no-param-reassign
      event.target.src = webpSupport ? _images.defaultBuilding.webp.building_def_webp : _images.defaultBuilding.png.building_def_png;
    },
    effect: "blur",
    src: _paulCorePackage.functions.getSupportedImg({
      webpSupport,
      urls: hasimages === null || hasimages === void 0 ? void 0 : hasimages[0],
      imgSizeKey: _paulCorePackage.constants.imgSizeKeys.preview,
      defaultImg: {
        webp: _images.defaultBuilding.webp.building_def_webp,
        original: _images.defaultBuilding.png.building_def_png
      }
    }),
    width: 198,
    height: 149
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    variant: "subtitle1",
    sx: _objectSpread({
      fontWeight: 'bold',
      lineHeight: '100%',
      color: _constants.colors['main-color-cl-01']
    }, _constants.styles.textCrop(2))
  }, tV(thingSiteAddress)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "span",
    variant: "subtitle1",
    sx: _objectSpread({
      lineHeight: '100%',
      color: _constants.colors['main-color-cl-01']
    }, _constants.styles.textCrop(2))
  }, tV(thingZIPCode), " ", tV(thingCity)));
};
exports.SiteCard = SiteCard;
SiteCard.propTypes = {
  card: _Types.CardType.isRequired,
  index: _propTypes.default.number.isRequired,
  show: _propTypes.default.bool,
  isForMap: _propTypes.default.bool,
  goTo: _propTypes.default.func
};